import React, { useEffect, useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { Outlet, Link } from 'react-router-dom'
import { getCourseDashboardDetails_WebService } from '../../../components/core/_request'
import DashboardStats from '../../../components/course/DashboardStats'
import { Helmet } from 'react-helmet'

const DashboardCourse = () => {

  return (
    <Row className=''>
      <Helmet>
        <title>
          Your Enrolled Wellness Programs | United We Care Dashboard
        </title>
      </Helmet>
      <Col sm={3} className='pe-1 ' style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)" }}>
        <Nav className="flex-column">
          <div className='d-block d-md-none'>
            <DashboardStats />
          </div>
          <Nav.Item className=''>
            <Nav.Link eventKey="My Courses" style={{ boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.15)" }} className='bg-white text-grey'>
              <Link to="my-courses" className='text-decoration-none d-flex align-items-center gap-2 py-3 px-4 nav-link '>
                <img src="/assets/img/courses_collection.png" alt='' /><p className='font-inter m-0' style={{ color: "#667085", fontSize: '1rem' }}>My Courses</p>
              </Link>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className=''>
            <Nav.Link eventKey="Appointments History" style={{ boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.15)" }} className='bg-white text-grey'>
              <Link to="appointments-history" className='text-decoration-none d-flex align-items-center gap-2 py-3 px-4'>
                <img src="/assets/img/calender_sm_icon.png" alt='' /><p className='font-inter m-0' style={{ color: "#667085", fontSize: '1rem' }}> Appointments History</p>
              </Link>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className=''>
            <Nav.Link eventKey="My Worksheets" style={{ boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.15)" }} className='bg-white text-grey '>
              <Link to="my-worksheets" className='text-decoration-none d-flex align-items-center gap-2 py-3 px-4'>
                <img src="/assets/img/files_icon.png" alt='' /><p className='font-inter m-0' style={{ color: "#667085", fontSize: '1rem' }}> My Worksheets</p>
              </Link>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
      <Col sm={9} className='ps-1'>
        <div style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)" }}>
          <div className='d-none d-md-block'>
            <DashboardStats />
          </div>
          <Outlet />
        </div>
      </Col>
    </Row>
  )
}

export default DashboardCourse